import Recaptcha from 'react-google-recaptcha'
import React, { Component, Fragment } from 'react'
import { x } from '@xstyled/styled-components'
import Helmet from 'react-helmet'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { subscribeNewsletter, updateForm, reinitialize, toggleNewsletterSubscription } from '../../store/subscribe'

export class Subcribe extends Component {
  constructor (props) {
    super(props)
    this.handleChange = this.handleChange.bind(this)
    this.handleCheckboxChange = this.handleCheckboxChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.verifyCallback = this.verifyCallback.bind(this)
  }
  componentDidMount () {
    this.props.reinitialize()
  }
  handleChange (event) {
    let newState = {}
    newState[event.target.name] = event.target.value
    this.props.updateForm(newState)
  }
  handleCheckboxChange (event) {
    this.props.toggleNewsletterSubscription(event.target.value)
  }
  validateEmail (email) {
    var re = /^[^.@][^@]+@{1}[^@]+\.[^@]+[^.@]$/i
    return email.match(re)
  }
  validateName (name) {
    var re = /^[`a-zA-ZàèìòùÀÈÌÒÙáéíóúýÁÉÍÓÚÝâêîôûÂÊÎÔÛãñõÃÑÕäëïöüÿÄËÏÖÜŸçÇßØøÅåÆæœ' -]{2,45}$/i
    return name.match(re)
  }
  verifyCallback () {
    this.props.updateForm({ captchaVerified: true })
  }
  handleSubmit (event) {
    event.preventDefault()
    if (!this.validateEmail(this.props.email)) {
      this.props.updateForm({ output: 'Please enter a valid email address' })
      return false
    } else if (!this.validateName(this.props.firstName)) {
      this.props.updateForm({ output: 'Please enter a valid first name' })
      return false
    } else if (!this.validateName(this.props.lastName)) {
      this.props.updateForm({ output: 'Please enter a valid last name' })
      return false
    } else if (this.props.listIds.length < 1) {
      this.props.updateForm({ output: 'Please select at least one newsletter' })
      return false
    } else if (!this.props.captchaVerified) {
      this.props.updateForm({ output: 'Please enter a Captcha to verify that you are not a robot' })
      return false
    }
    this.props.subscribeNewsletter(this.props.firstName, this.props.lastName, this.props.email, this.props.listIds)
    return true
  }

  render () {
    if (!this.props.isSubmitting && !this.props.hasSubmitted) {
      return (
        <>
          <x.main px={20} mt={{ sm: '96px', lg: '173px' }} w='100%' maxWidth={1260} mx='auto'>
            <Helmet title='Sign up to Receive our Newsletters | IOL'
              description='Sign up for IOL`s newsletters and receive the latest news, sport, motoring, business, entertainment and lifestyle updates in your inbox.'>
              <script src='https://www.google.com/recaptcha/api.js' async defer />
            </Helmet>
            <x.div w='100%' maxWidth={1220} mx='auto' my={50}>
              <x.h1 text='h1' borderWidth='0 0 1px 0' borderStyle='solid' borderColor='divider' pb={10} mb={20}>Newsletter Subscription Form</x.h1>
              <x.form maxWidth={550} display='flex' flexDirection='column' id='item-form' name='item-form' encType='text/plain' onSubmit={this.handleSubmit}>
                <x.p text='small' mb={15}>Fill in your details and select which newsletters you would like to subscribe to.</x.p>
                <x.label text='madium' display='block' htmlFor='firstName' mb={15}>First Name:</x.label>
                <x.input mb={15} bg='ltGrey' p={10} text='medium' id='firstName' placeholder='Type your first name' required='required' type='text' name='firstName' value={this.props.firstName} onChange={this.handleChange} />
                <x.label text='madium' display='block' htmlFor='lastName' mb={15}>Last Name:</x.label>
                <x.input mb={15} bg='ltGrey' p={10} text='medium' id='lastName' placeholder='Type your last name' required='required' type='text' name='lastName' value={this.props.lastName} onChange={this.handleChange} />
                <x.label text='madium' display='block' htmlFor='email' mb={15}>Email:</x.label>
                <x.input mb={15} bg='ltGrey' p={10} text='medium' id='email' placeholder='example@domain.com' required='required' type='email' name='email' value={this.props.email} onChange={this.handleChange} />
                <x.p text='h5' my={15}>Select the Newsletters you would like to receive:</x.p>
                <x.div mb={20} className='checkboxes'>
                  <input id='OJ4zwxCfnDwA9iw1aRjXdg' type='checkbox' value='OJ4zwxCfnDwA9iw1aRjXdg' onChange={this.handleCheckboxChange} checked={this.props.listIds.includes('OJ4zwxCfnDwA9iw1aRjXdg')} /><label htmlFor='OJ4zwxCfnDwA9iw1aRjXdg'><span />Business Report</label>
                  <input id='UvMIi9m2RuP4MphsG52Vvw' type='checkbox' value='UvMIi9m2RuP4MphsG52Vvw' onChange={this.handleCheckboxChange} checked={this.props.listIds.includes('UvMIi9m2RuP4MphsG52Vvw')} /><label htmlFor='UvMIi9m2RuP4MphsG52Vvw'><span />IOL Daily</label>
                  <input id='76CEXq8GPTio5JhV892n6ttQ' type='checkbox' value='76CEXq8GPTio5JhV892n6ttQ' onChange={this.handleCheckboxChange} checked={this.props.listIds.includes('76CEXq8GPTio5JhV892n6ttQ')} /><label htmlFor='76CEXq8GPTio5JhV892n6ttQ'><span />Personal Finance</label>
                  <input id='D6JzNYvmEh2D8763k8hPHlcA' type='checkbox' value='D6JzNYvmEh2D8763k8hPHlcA' onChange={this.handleCheckboxChange} checked={this.props.listIds.includes('D6JzNYvmEh2D8763k8hPHlcA')} /><label htmlFor='D6JzNYvmEh2D8763k8hPHlcA'><span />Sport</label>
                  <input id='R0qYpcb4Ue2SnS892ISLR3zw' type='checkbox' value='R0qYpcb4Ue2SnS892ISLR3zw' onChange={this.handleCheckboxChange} checked={this.props.listIds.includes('R0qYpcb4Ue2SnS892ISLR3zw')} /><label htmlFor='R0qYpcb4Ue2SnS892ISLR3zw'><span />Education</label>
                  <input id='yxHoP7IZr8gCEU1gsy7Ppg' type='checkbox' value='yxHoP7IZr8gCEU1gsy7Ppg' onChange={this.handleCheckboxChange} checked={this.props.listIds.includes('yxHoP7IZr8gCEU1gsy7Ppg')} /><label htmlFor='yxHoP7IZr8gCEU1gsy7Ppg'><span />Lifestyle</label>
                  <input id='FsPwab7kNQUCR1fO2edIZA' type='checkbox' value='FsPwab7kNQUCR1fO2edIZA' onChange={this.handleCheckboxChange} checked={this.props.listIds.includes('FsPwab7kNQUCR1fO2edIZA')} /><label htmlFor='FsPwab7kNQUCR1fO2edIZA'><span />Motoring</label>
                  <input id='UiIQSJPTxuu0RwnQs7632NQg' type='checkbox' value='UiIQSJPTxuu0RwnQs7632NQg' onChange={this.handleCheckboxChange} checked={this.props.listIds.includes('UiIQSJPTxuu0RwnQs7632NQg')} /><label htmlFor='UiIQSJPTxuu0RwnQs7632NQg'><span />Entertainment</label>
                  <input id='oOtAMxQ3QF3CP892cFL4pnIQ' type='checkbox' value='oOtAMxQ3QF3CP892cFL4pnIQ' onChange={this.handleCheckboxChange} checked={this.props.listIds.includes('oOtAMxQ3QF3CP892cFL4pnIQ')} /><label htmlFor='oOtAMxQ3QF3CP892cFL4pnIQ'><span />Travel</label>
                  <input id='XcmPmowzjES3p8laNTW892GA' type='checkbox' value='XcmPmowzjES3p8laNTW892GA' onChange={this.handleCheckboxChange} checked={this.props.listIds.includes('XcmPmowzjES3p8laNTW892GA')} /><label htmlFor='XcmPmowzjES3p8laNTW892GA'><span />Technology</label>
                </x.div>
                <Recaptcha sitekey='6LfsLz4cAAAAALqO3FpVjEBCqOp-wBHVF9qJXuWn' onChange={this.verifyCallback} />
                {(!(this.props.output === '') &&
                  <p
                    error
                    header='Errors'
                    content={this.props.output}
                  />
                )}
                <x.input mt={15} mb={15} bg='red' p={10} text='medium' color='white' textTransform='uppercase' fontWeight='medium' w={150} id='submitbutton' type='submit' value='Submit' />
                <input type='hidden' name='form_hash' value='n1opdyilO0bEvwBq' id='form_hash' />
              </x.form>
            </x.div>
          </x.main>
        </>
      )
    } else if (this.props.isSubmitting) {
      return (
        <>
          <Helmet title='Article' />
          <p>Submitting your subscription request</p>
        </>
      )
    } else if (this.props.hasSubmitted) {
      return (
        <>
          <x.main px={20} mt={{ sm: '96px', lg: '173px' }} w='100%' maxWidth={1260} mx='auto'>
            <Helmet title='Thank you for your submission' />
            <x.div w='100%' maxWidth={1220} mx='auto' my={50}>
              <x.h1 text='h1' borderWidth='0 0 1px 0' borderStyle='solid' borderColor='divider' pb={10} mb={20}>Thank you for your subscription</x.h1>
              <p>Please check your email inbox to verify your subscription.</p>
            </x.div>
          </x.main>
        </>
      )
    }
  }
}

const mapStateToProps = (state) => (state.subscribe)
const mapDispatchToProps = (dispatch) => bindActionCreators({ subscribeNewsletter, reinitialize, updateForm, toggleNewsletterSubscription }, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(Subcribe)
